import { render } from "./AIDraw.vue?vue&type=template&id=11c25ec3&scoped=true"
import script from "./AIDraw.vue?vue&type=script&lang=js"
export * from "./AIDraw.vue?vue&type=script&lang=js"

import "./AIDraw.vue?vue&type=style&index=0&id=11c25ec3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c25ec3"]])

export default __exports__